<template>
  <div class="filters-section">
    <h4>Filtros</h4>

    <!-- Filtros de Formato -->
    <div class="filter-group">
      <h5>Formato</h5>
      <div class="filter-options">
        <label
          v-for="format in availableFormats"
          :key="format"
          class="filter-option"
        >
          <input
            type="checkbox"
            :checked="formatFilters[format]"
            @change="$emit('toggle-format-filter', { format, checked: $event.target.checked })"
            class="filter-option__input"
          >
          <span
            class="filter-option__box"
            :style="{ '--checkbox-color': getFormatColor(format) }"
          ></span>
          <span>{{ getFormatLabel(format) }}</span>
        </label>
      </div>
    </div>

    <!-- Filtros de Envase -->
    <div class="filter-group">
      <h5>Envase</h5>
      <div class="filter-options">
        <label
          v-for="packaging in availablePackagings"
          :key="packaging"
          class="filter-option"
        >
          <input
            type="checkbox"
            :checked="packagingFilters[packaging]"
            @change="$emit('toggle-packaging-filter', { packaging, checked: $event.target.checked })"
            class="filter-option__input"
          >
          <span
            class="filter-option__box"
            :style="{ '--checkbox-color': getPackagingBorderColor(packaging) }"
          ></span>
          <span>{{ getPackagingLabel(packaging) }}</span>
        </label>
      </div>
    </div>

    <!-- Filtros de Custodia -->
    <div
      class="filter-group"
      v-if="availableCustodies.length > 0"
    >
      <h5>Custodia</h5>
      <div class="filter-options">
        <label
          v-for="custody in availableCustodies"
          :key="custody"
          class="filter-option"
        >
          <input
            type="checkbox"
            :checked="custodyFilters[custody]"
            @change="$emit('toggle-custody-filter', { custody, checked: $event.target.checked })"
            class="filter-option__input"
          >
          <span class="filter-option__box"></span>
          <span>{{ custody }}</span>
        </label>
      </div>
    </div>

    <!-- Filtros de Planta Proceso -->
    <div
      class="filter-group"
      v-if="availableProcessPlants.length > 0"
    >
      <h5>Planta Proceso</h5>
      <div class="filter-options">
        <label
          v-for="processPlant in availableProcessPlants"
          :key="processPlant"
          class="filter-option"
        >
          <input
            type="checkbox"
            :checked="processPlantFilters[processPlant]"
            @change="$emit('toggle-process-plant-filter', { processPlant, checked: $event.target.checked })"
            class="filter-option__input"
          >
          <span class="filter-option__box"></span>
          <span>{{ getProcessPlantLabel(processPlant) }}</span>
        </label>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable camelcase */
export default {
  name: 'CalendarFilters',
  props: {
    availableFormats: {
      type: Array,
      default: () => [],
    },
    availablePackagings: {
      type: Array,
      default: () => [],
    },
    availableCustodies: {
      type: Array,
      default: () => [],
    },
    availableProcessPlants: {
      type: Array,
      default: () => [],
    },
    formatFilters: {
      type: Object,
      default: () => ({}),
    },
    packagingFilters: {
      type: Object,
      default: () => ({}),
    },
    custodyFilters: {
      type: Object,
      default: () => ({}),
    },
    processPlantFilters: {
      type: Object,
      default: () => ({}),
    },
  },
  emits: [
    'toggle-format-filter',
    'toggle-packaging-filter',
    'toggle-custody-filter',
    'toggle-process-plant-filter',
  ],
  methods: {
    getFormatColor(format) {
      const colors = {
        entero: '#56B686',
        harinado: '#D85796',
        multiparticle: '#3076EE',
        pelet_3: '#E31431',
        pelet_6: '#E87B37',
        pelet_8: '#845FEF',
        pelet_12: '#EBA23D',
      };

      return colors[format] || '#3076EE';
    },
    getPackagingBorderColor(packaging) {
      const colors = {
        granel: '#020405',
        ensacado: '#4CE51E',
        maxisaco: '#0CEEE7',
      };

      return colors[packaging] || '#3076EE';
    },
    getFormatLabel(format) {
      const labels = {
        entero: 'Entero',
        harinado: 'Harinado',
        multiparticle: 'Multipartícula',
        pelet_3: 'Pelet 3',
        pelet_6: 'Pelet 6',
        pelet_8: 'Pelet 8',
        pelet_12: 'Pelet 12',
      };

      return labels[format] || 'Otro';
    },
    getPackagingLabel(packaging) {
      const labels = {
        granel: 'Granel',
        ensacado: 'Ensacado',
        maxisaco: 'Maxisaco',
      };

      return labels[packaging] || 'Otro';
    },
    getProcessPlantLabel(processPlant) {
      const labels = {
        line1: 'Línea 1',
        line2: 'Línea 2',
        reception: 'Recepción',
      };

      return labels[processPlant] || 'No especificado';
    },
  },
};
</script>

<style scoped>
.filters-section {
  background: #fff;
  border: 1px solid #d3d8dc;
  box-shadow: none;
  border-radius: 0;
  padding: 20px;
  position: static;
  width: 270px;
}

.filters-section h4 {
  margin: 0 0 15px 0;
  color: #4e4e51;
  font-size: 1em;
  font-weight: bold;
  text-transform: uppercase;
}

.filter-group {
  margin-bottom: 0px;
}

.filter-group:last-child {
  margin-bottom: 0;
}

.filter-group h5 {
  margin: 0 0 0px 0;
  color: #95a5a6;
  font-size: 13px;
  font-weight: normal;
  text-transform: uppercase;
  font-family: 'Source Sans Pro', sans-serif;
}

.filter-options {
  display: flex;
  flex-direction: column;
  gap: 0px;
}

.filter-option {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #4e4e51;
  cursor: pointer;
  padding: 2px 0;
  font-family: 'Source Sans Pro', sans-serif;
  position: relative;
}

.filter-option__input {
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
  pointer-events: none;
}

.filter-option__box {
  width: 18px;
  height: 18px;
  border: 2px solid var(--checkbox-color, #4e4e51);
  border-radius: 3px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  transition: background-color 0.2s ease, border-color 0.2s ease;
  position: relative;
  flex-shrink: 0;
}

.filter-option__box::after {
  content: '';
  width: 6px;
  height: 10px;
  border: 2px solid #fff;
  border-top: 0;
  border-left: 0;
  transform: rotate(45deg);
  opacity: 0;
  transition: opacity 0.15s ease;
}

.filter-option__input:checked + .filter-option__box {
  background-color: var(--checkbox-color, #4e4e51);
  border-color: var(--checkbox-color, #4e4e51);
}

.filter-option__input:checked + .filter-option__box::after {
  opacity: 1;
}

.filter-option__input:focus-visible + .filter-option__box {
  outline: 2px solid #3076EE;
  outline-offset: 2px;
}

.filter-option:hover {
  color: #4e4e51;
}
</style>
